import {get} from 'lodash';

export default (state: any, {isLoading}: any) => ({
  ...state,
  healthcare: {
    ...get(state, 'healthcare', {}),
    isLoading,
  },
});
